import gql from 'graphql-tag';

export const CREATE_TASK = gql`
  mutation createTask(
    $createTaskInput: CreateTaskInput!
    $taskCheckListItems: [CreateTaskCheckListItemInput]
    $taskVariants: [CreateTaskVariantInput]
  ) {
    createTask(
      createTaskInput: $createTaskInput
      taskCheckListItems: $taskCheckListItems
      taskVariants: $taskVariants
    ) {
      id
      taskName
      taskCode
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation updateTask(
    $updateTaskInput: UpdateTaskInput!
    $taskCheckListItems: [UpdateTaskCheckListItemInput]
    $taskVariants: [UpdateTaskVariantInput]
  ) {
    updateTask(
      updateTaskInput: $updateTaskInput
      taskCheckListItems: $taskCheckListItems
      taskVariants: $taskVariants
    ) {
      id
      taskName
      taskCode
      taskCheckListItems {
        id
        taskId
        itemName
      }
    }
  }
`;

export const REMOVE_TASK_VARIANT_ITEM = gql`
  mutation removeTaskVariantItem($id: Int!) {
    removeTaskVariantItem(id: $id)
  }
`;
export const REMOVE_TASK_LIST_ITEM = gql`
  mutation removeTaskCheckListItem($id: Int!) {
    removeTaskCheckListItem(id: $id)
  }
`;

export const REMOVE_TASK = gql`
  mutation removeTask($id: Int!) {
    removeTask(id: $id)
  }
`;
